import React from 'react';
import Modal from './Modal';
import {CustomizeItemContext} from '../../CustomizeItemContext';
import SelectedCustomizeItemSelectOptions from './SelectedCustomizeItemSelectOptions';
import WeightSlider from '../WeightSlider';

export default () => {
  const {clientPreleadCustomizeItem} = React.useContext(CustomizeItemContext);
  const customizeItemName = clientPreleadCustomizeItem?.name;
  const [visible, setVisible] = React.useState(false);
  const onClose = () => setVisible(false);
  return (
    <>
      <div className="flex flex-col gap-4 p-4 bg-white">
        <div className="flex flex-col gap-2 items-start">
          <div className="flex w-full items-center justify-between">
            <div>
              <h2 className="text-base m-0 font-bold">{customizeItemName}</h2>
              <p className="m-0 text-sm">
                {`重要度を高める${customizeItemName}を選択してください。`}
              </p>
            </div>
            <WeightSlider />
          </div>
          <button
            className="bg-white border border-c-border rounded h-8 text-sm px-4 cursor-pointer"
            onClick={() => {
              setVisible(true);
            }}>
            {`${customizeItemName}を選択`}
          </button>
          <SelectedCustomizeItemSelectOptions />
        </div>
      </div>
      {visible && (
        <>
          <Modal visible onClose={onClose} />
        </>
      )}
    </>
  );
};
